/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { withContext } from 'fierry/react.old/native';


export default withContext();
